import React from 'react';
import { ADMIN_USERS } from '../../Pages';
import history from '../../../core/history';

export default {
  path: ADMIN_USERS.pageURL,
  async action() {
    const { default: UserManager } = await import('./UserManager');
    return (
      <UserManager
        key={'admin_users_management'}
        partnerAccount={history.location.state.partnerAccount}
        partnerNumber={history.location.state.partnerNumber}
      />
    );
  },
};
